module.exports = __webpack_public_path__ + "img/footprints - frodoSam.ecdf156c.svg";